import { useEffect, useState } from "react";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { StoreStorageService } from "./core/_request";
import { HttpStatusCode } from "axios";
import {
  useStoreStorageListState,
  useStoreStorageStore,
} from "./store/StoreStorageStore";
import { Loader } from "../../../common/components/Loader/Loader";
import StoreStorageForm from "./StoreStorageForm";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";

const StoreStorageList = () => {
  const {
    setStoreStorageList,
    storeStorageList,
    actioned,
    totalItems,
    setActioned,
  } = useStoreStorageStore();
  const { pageState, setPageState, resetPageState } =
    useStoreStorageListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "name",
      title: "Nom",
      dataIndex: "name",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "capacity",
      title: "Capacité (T)",
      dataIndex: "capacity",
      show: true,
      isCanSort: true,
      // searchType: "text"
    },
    {
      key: "cementCapacity",
      title: "Capacité ciment (T)",
      dataIndex: "cementCapacity",
      show: true,
      isCanSort: true,
      // searchType: "text"
    },
  ];

  useEffect(() => {
    fetchAllStoreStorage(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onClickOnAdd = () => {
    onShowAddHandler();
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await StoreStorageService.getStoreStorage(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await StoreStorageService.deleteStoreStorage(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllStoreStorage();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllStoreStorage = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await StoreStorageService.getStoreStorageList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setStoreStorageList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader title="Magasins" isEnableAdd onClickOnAdd={onClickOnAdd} />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={storeStorageList}
            params={pageState}
            onAction={onActionClick}
            isCanDelete={() => true}
            isCanEdit={() => true}
            onSearch={handleSetParams}
            onSort={handleSetParams}
            onResetSearch={resetPageState}
            onChangePage={handleSetParams}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <StoreStorageForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};

export default StoreStorageList;
